import { useContext, useEffect, useState } from "react";
import LegoAdminPageContext from "../../../pages/legoAdminPageContext";
import StableUrlsCommitEditor from "./StableUrlsCommitEditor";

export default function StableUrlsWidget({ type = 'fusebox' }) {
  const { page } = useContext(LegoAdminPageContext);
  const [pendingChangesCount, setPendingChanges] = useState(null);

  const stableUrlsService = page.service('/services/stable-urls/changes');

  const fetchPendingChanges = async () => {
    const data = await stableUrlsService.find({ query: { type, $count: true } });
    setPendingChanges(data);
  }

  const openModal = () => {
    page.openModal(<StableUrlsCommitEditor type={type} />, { title: `Publish url changes - ${type}` });
  }

  useEffect(() => {
    const handler = (changes) => {
      if (changes.some(c => c.type === type)) {
        fetchPendingChanges();
      }
    };    
    stableUrlsService.on('urls-pending-changes', handler);

    fetchPendingChanges();

    return () => stableUrlsService.removeListener('urls-pending-changes', handler);
  }, [type]);

  if (pendingChangesCount === null) {
    return <span>
      <span className="btn btn-xs badge-secondary" onClick={openModal}>Loading...</span>
    </span>;
  } else if (pendingChangesCount > 0) {
    return <span>
      <span className="btn btn-xs badge-warning" onClick={openModal}>⚠ {pendingChangesCount} CHANGES</span>
    </span>
  } else {
    return <span>
      <span className="btn btn-xs badge-success" onClick={openModal}>✔ URLs up to date</span>
    </span>
  }
}